import { PortalPlugin, Lifecycles } from './PortalPlugin';

/**
 * Since the plugin instance comes from a javascript file that is outside framework control,
 * there is no guarantee of type safety. So check the shape of the object, assuming nothing.
 * Return a plugin with invalid parcels stripped out, or throw if it's completely invalid.
 */
export class PluginValidator {

  validate = (plugin: PortalPlugin) => {

    const isParcelConfig = (object: Lifecycles) => (object && object.mount && object.unmount && object.bootstrap);

    if (!plugin || typeof plugin !== 'object') {
      throw new Error('Plugin must be an object!');
    }

    const { name } = plugin;

    if (!name) {
      console.warn(`WARNING: Found plugin without a name.`);
    }

    // check for legacy nav items (no longer part of the PortalPlugin interface)
    if ((plugin as any).navItems) {
      console.warn(`WARNING: Ignoring navItems in plugin "${name}" because it is no longer supported. Use "navigation" table in DynamoDB instead.`);
    }

    // validate widgets (filtering out invalid)
    const dashboardWidgets = (plugin.dashboardWidgets || []).filter((widget, i) => {
      if (!widget || !isParcelConfig(widget.parcelConfig)) {
        console.error(`Skipping widget-${i} in plugin "${name}" because it is invalid.`);
        return false;
      }
      return true;
    });

    // validate pages (filtering out invalid)
    const pages = (plugin.pages || []).filter((page, i) => {
      if (!page || !page.path || !isParcelConfig(page.parcelConfig)) {
        console.error(`Skipping page-${i} in plugin "${name}" because it is invalid.`);
        return false;
      }
      return true;
    });

    // if no widgets or pages, we can't do anything with it
    if (!dashboardWidgets.length && !pages.length) {
      throw new Error(`Plugin "${name}" is invalid because it has no valid dashboardWidgets or pages.`);
    }

    return { ...plugin, dashboardWidgets, pages };
  }
}



// WEBPACK FOOTER //
// ./src/framework/PluginValidator.ts